import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoIsForSection() {
  const isFor = ['Emprendedores y creativos con TDAH (diagnosticado o no).', "Profesionales que se sienten 'quemados' por la sobreestimulación digital.", 'Personas que procrastinan no por falta de ganas, sino por exceso de ansiedad.', 'Estudiantes que pasan horas frente al libro sin lograr leer una sola página.'];
  const isNotFor = ['Personas que buscan una cura médica o farmacológica.', 'Quienes esperan que el éxito llegue sin aplicar los 5 minutos de protocolo.', 'Perfiles corporativos que buscan optimización de KPIs tradicionales.'];
  return <section className="py-20 relative bg-black/30 border-y border-white/5" data-id="element-145">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-146">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-147">
          {/* Who is it for */}
          <div className="bg-white/5 border border-cyan-500/20 rounded-3xl p-8 relative overflow-hidden" data-id="element-148">
            <div className="absolute top-0 right-0 w-32 h-32 bg-cyan-500/10 rounded-full blur-[40px]" data-id="element-149" />
            <h3 className="text-2xl font-bold text-slate-50 mb-6 flex items-center gap-3" data-id="element-150">
              <span className="bg-cyan-500/20 text-cyan-400 p-2 rounded-lg" data-id="element-151">
                <CheckIcon className="w-5 h-5" data-id="element-152" />
              </span>
              Para quién ES
            </h3>
            <ul className="space-y-4" data-id="element-153">
              {isFor.map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-300" data-id="element-154">
                  <span className="text-cyan-400 mt-1" data-id="element-155">•</span>
                  <span className="leading-relaxed" data-id="element-156">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Who is it NOT for */}
          <div className="bg-white/5 border border-white/10 rounded-3xl p-8 opacity-80" data-id="element-157">
            <h3 className="text-2xl font-bold text-slate-50 mb-6 flex items-center gap-3" data-id="element-158">
              <span className="bg-red-500/20 text-red-400 p-2 rounded-lg" data-id="element-159">
                <XIcon className="w-5 h-5" data-id="element-160" />
              </span>
              Para quién NO ES
            </h3>
            <ul className="space-y-4" data-id="element-161">
              {isNotFor.map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-400" data-id="element-162">
                  <span className="text-red-400/70 mt-1" data-id="element-163">•</span>
                  <span className="leading-relaxed" data-id="element-164">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}